<template>
    <div>
        <my-dialog ref="dialog" title="我的浏览历史记录" :hide-callback="closeDialogCallback">
            <div align="center">
                <div v-if="noData" class="margin-top-20px">暂无记录</div>
                <no-signal
                    v-if="noSignalVisible"
                    ref="noSignal"
                    display-mode="vertical"
                    :retry-handlers="[retryNextPageHandler()]"
                    :retry-basis="false"
                    :margin-top="35"></no-signal>
                <list ref="list" :next-page-func="nextPage" :scroll-on-body="false" loading-class="margin-top-20px"></list>
            </div>
        </my-dialog>
    </div>
</template>

<script>
    import List from "../../list/List";
    import MyDialog from "../../commons/MyDialog";
    import { loadViewHis } from "../../../data/user";
    import { errorMessage, ShowEntityMode, Styles } from "../../../utils";
    import { TimeoutError, NetworkError } from '@shangyang/error';

    export default {
        name: "UserViewHis",
        components: { List, MyDialog },
        data(){
            return {
                pageNum: 1,
                noData: false,
                noSignalVisible: false,
            }
        },
        methods: {
            show(){
                // 延时显示
                setTimeout(()=>{
                    this.$refs.dialog.show();
                    this.reset();
                    this.$store.commit('setShowEntityMode', ShowEntityMode.PopupPageMode);
                    this.$store.commit('setIsProfileNameNavigble', true);
                    Styles.bodyScrollLocked = true;
                    this.$nextTick(()=>{
                        (async()=>{
                            await this.$refs.list.initData(); // initData() 会回调 nextPage 方法
                        })();
                    });
                }, 100);  // 调整为 100ms 为适应 stickpop 的快速点击响应
            },
            reset(){
                this.noData = false;
                this.noSignalVisible = false;
                this.pageNum = 1;
            },
            async nextPage(){
                try {
                    let page = await loadViewHis(this.pageNum);
                    console.log(`next page called and get view his: ${JSON.stringify(page)}`);
                    if (this.pageNum === 1 && page.length === 0) {
                        this.noData = true
                    }
                    this.pageNum++;
                    this.noSignalVisible = false;
                    return page;
                } catch (error){
                    console.error(error);
                    // 如果是第一页就出现了网络异常，将其切换成 main page 异常。
                    if ((error instanceof TimeoutError || error instanceof NetworkError) && this.pageNum === 1) {
                        errorMessage(error.message);
                        this.noSignalVisible = true; // 显示 no signal comp
                        let err = new NetworkError('no signal main page error, has been handled by channel');
                        err.handled = true;  // 通知 List page 我已经处理了，下一级就不要再处理了。
                        throw err;
                    }
                    throw error; // 必须抛出这个异常，否则 List 的 nextPage 调用该句柄的时候会认为是正常返回导致异常
                }
            },
            retryNextPageHandler(){
                return this.$refs.list.initData;
            },
            closeDialogCallback(){
                console.log('caught hide event, the dialog is closed');
                Styles.bodyScrollLocked = false;  // 解锁，注意上锁是在 this.show() 中进行的。
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user/center/UserViewHis.vue